// extracted by mini-css-extract-plugin
export default {"Wrapper":"Pagination_Wrapper__lzCDB","pagination":"Pagination_pagination__mVvOv","active":"Pagination_active__q3h4d"};